import { API_URL } from '../config/api';
import { tokenManager } from '../context/AuthContext';
import { parseResponse } from './expenseVouchersApi';

// API client for the Expense operational features (Phase 5B-2): employee dashboard, voucher
// print view and weekly reminders. Authorization, every count and every
// amount are decided by the server; the UI only displays them.

const request = async (method, path, forbidden) => parseResponse(await fetch(`${API_URL}${path}`, {
  method,
  headers: { ...tokenManager.getAuthHeader(), 'Content-Type': 'application/json' },
}), forbidden);

export const operationsApi = {
  myDashboard: () => request('GET', '/expenses/dashboard/me', 'You do not have access to Expenses.'),
  printVoucher: (id) => request('GET', `/expenses/print/${id}`),
  reminders: () => request('GET', '/expenses/accounts/reminders', 'You do not have Expense Accounts access.'),
  runReminders: () => request('POST', '/expenses/accounts/reminders/run', 'You do not have Expense Accounts access.'),
};

// Wording for a wallet position. Positive balance = held by the employee (the company can
// recover it); negative = owed to the employee.
export const WALLET_POSITION_LABELS = {
  RECOVERABLE: 'Recoverable',
  PAYABLE: 'Payable to employee',
  ZERO: 'Settled (zero)',
};

export const REMINDER_STAGE_LABELS = {
  ACCOUNTS_REVIEW: 'Accounts review',
  REPORTING_APPROVAL: 'Reporting approval',
  MANAGEMENT_APPROVAL: 'Management approval',
  APPROVER_BLOCKED: 'Approver inactive - re-route',
  ACCOUNTS_PAYMENT: 'Booking / payment',
};

export const SEVERITY_META = {
  BLOCKER: { label: 'Blocker', color: 'error' },
  WARNING: { label: 'Warning', color: 'warning' },
  INFO: { label: 'Info', color: 'info' },
};

// Opens the print view of a voucher in a new tab (same app, same login). The page is
// mounted outside the menu layouts so it prints cleanly.
export const voucherPrintPath = (id) => `/expense-print/${id}`;
export const openVoucherPrint = (id) => {
  window.open(`${process.env.PUBLIC_URL || ''}${voucherPrintPath(id)}`, '_blank', 'noopener');
};
